import React, { useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { useFormik } from 'formik';

const CompanyInfo = ({ profileInfo }) => {
    const [loadingBtn, setLoadingBtn] = useState(false);

    const formik = useFormik({
        initialValues: {
            id: '',
            name: '',
            email: '',
            phone: '',
            status: '',
            roleId: '',
            password: ''
        }
    });

    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="grid p-fluid">
                <div className="col-12 md:col-4">
                    <div className="field mb-3">
                        <label htmlFor="email">Company Name</label>
                        <InputText id="email" name="email" placeholder="Account Number" value={profileInfo?.companyName} maxLength={30} disabled />
                        {formik.touched.email && formik.errors.email && <small className="p-error">{formik.errors.email}</small>}
                    </div>
                </div>
                <div className="col-12 md:col-4">
                    <div className="field mb-3">
                        <label htmlFor="name">Company Email</label>
                        <InputText id="name" name="name" placeholder="Bank Name" value={profileInfo?.companyEmail} maxLength={30} disabled />
                        {formik.touched.name && formik.errors.name && <small className="p-error">{formik.errors.name}</small>}
                    </div>
                </div>
                <div className="col-12 md:col-4">
                    <div className="field mb-3">
                        <label htmlFor="WebsiteLink">Company Website Link</label>
                        <InputText id="WebsiteLink" name="WebsiteLink" placeholder="company Website Link" value={profileInfo?.companyWebsiteLink} maxLength={30} disabled />
                        {formik.touched.WebsiteLink && formik.errors.WebsiteLink && <small className="p-error">{formik.errors.WebsiteLink}</small>}
                    </div>
                </div>
                
            </div>
        </form>
    );
};

export default CompanyInfo;
